'use client'
import React from 'react'
import { useTranslations } from 'next-intl'

import { BreadcrumbsComponent, BreadcrumbItem } from './Breadcrumbs'

interface BreadcrumbsWrapperProps {
    items: BreadcrumbItem[]
    locale: string
}

const BreadcrumbsWrapper: React.FC<BreadcrumbsWrapperProps> = ({ items, locale }) => {
    const t = useTranslations('common')
    
    return (
        <BreadcrumbsComponent 
            items={items}
            locale={locale}
            homeLabel={t('home')}
        />
    )
}

export { BreadcrumbsWrapper }
export default BreadcrumbsWrapper
export type { BreadcrumbItem }